import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
// Define una interfaz para las acciones personalizadas
export interface TableAction {
  label: string;
  handler: (item: any) => void;
  icon: string | ((item: any) => string);
  colorClass: string | ((item: any) => string);
  visible?: (item: any) => boolean;
}

@Component({
  selector: "app-paginacion",
  templateUrl: "./table-paginator.component.html",
  styleUrls: ["./table-paginator.css"],
})
export class TablePaginatorComponent implements OnInit {
  @Input() currentPage: number = 1;
  @Input() pageSize: number = 25;
  @Input() totalItems: number = 0;
  @Input() paginatedData: any[] = []; // Nueva entrada para los datos paginados
  @Input() headers: { key: string; label: string }[] = []; // Nueva entrada para las cabeceras de la tabla
  @Input() actions: TableAction[] = []; // ¡Nueva entrada para acciones personalizadas!

  pageSizes = [5, 10, 25, 50, 100];
  @Input() selectedPageSize = 25;

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();
  @Input() loading: boolean = true;
  @Input() paginator: boolean = true;
  // Los eventos viewItem, editItem, deleteItem se reemplazan por la nueva entrada 'actions'

  ngOnInit() {
    // Inicialización si es necesaria
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.selectedPageSize);
  }

  getActionIcon(action: TableAction, item: any): string {
    return typeof action.icon === "function" ? action.icon(item) : action.icon;
  }

  getActionColorClass(action: TableAction, item: any): string {
    return typeof action.colorClass === "function"
      ? action.colorClass(item)
      : action.colorClass;
  }

  onPageChange(newPage: number): void {
    if (newPage >= 1 && newPage <= this.totalPages) {
      this.pageChange.emit(newPage);
    }
  }

  onPageSizeChange(): void {
    this.pageSizeChange.emit(this.selectedPageSize);
  }

  getPageNumbers(): (number | string)[] {
    const totalPages = this.totalPages;
    const currentPage = this.currentPage;
    const maxVisible = 7;

    // Si hay pocas páginas, mostrar todas
    if (totalPages <= maxVisible) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const pages: (number | string)[] = [];

    if (currentPage <= 4) {
      // Mostrar las primeras 5 páginas
      for (let i = 1; i <= 5; i++) {
        pages.push(i);
      }
    } else if (currentPage >= totalPages - 3) {
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(currentPage - 1);
      pages.push(currentPage);
      pages.push(currentPage + 1);
    }

    return pages;
  }

  get totalColumns(): number {
    return this.headers.length + (this.actions?.length > 0 ? 2 : 1);
  }

  getIndex(i: number): number {
    return i + 1 + (this.currentPage - 1) * this.selectedPageSize;
  }

  /**
   * Ejecuta la función handler de una acción personalizada.
   * @param action El objeto de acción (TableAction)
   * @param item El item de la fila sobre el que se ejecuta la acción
   */
  onActionClick(action: TableAction, item: any): void {
    if (action.handler) {
      action.handler(item);
    }
  }

  getVisibleActions(item: any) {
    let action = this.actions.filter(
      (action) => !action.visible || action.visible(item),
    );

    return action;
  }
}
